import { useEffect, useState } from "react";

const useGetter = (get) => {
  const [data, setData] = useState();
  const [getting, setGetting] = useState(true);
  const [error, setError] = useState();

  const doGet = async () => {
    try {
      setData(await get());
      setError();
    } catch (e) {
      setError(e);
      setData();
    } finally {
      setGetting(false);
    }
  };

  useEffect(() => {
    doGet();
    // eslint-disable-next-line
  }, []);

  return [getting, data, error, doGet];
};

export default useGetter;
